module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('dn-spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f075672e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/loadings/LoadingSpinner.vue
// module id = 338
// module chunks = 1